import React from 'react';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select-v1';
import { get, isFunction } from 'lodash';
import clxBind from 'classnames/bind';
import Icon from '../Icon';
import Spin from '../Spin';
import styles from './styles.module.scss';
import './select.scss';

const clx = clxBind.bind(styles);

const Z_INDEX = '5';

class CustomSelect extends ReactSelect {
  constructor() {
    super();
    // react-select currently does not provide a way for customize loading indicator :(
    // so, we override it like this
    this.renderLoading = () => {
      if (!this.props.isLoading) {
        return null;
      }

      return (
        <span className="Select-loading-zone" aria-hidden>
          <Spin thickness={1} />
        </span>
      );
    };
  }
}

export default class Select extends React.Component {
  static propTypes = {
    placeholder: PropTypes.string,
    noResultsText: PropTypes.string,
    value: PropTypes.any,
    readOnly: PropTypes.bool,
    disabled: PropTypes.bool,
    onBlur: PropTypes.func,
    className: PropTypes.string,
    arrowClassName: PropTypes.string,
    clearClassName: PropTypes.string,
  };

  static defaultProps = {
    placeholder: '---',
    noResultsText: 'No results',
    value: '',
    readOnly: false,
    disabled: false,
    onBlur: undefined,
    className: undefined,
    arrowClassName: undefined,
    clearClassName: undefined,
  };

  handleBlur = () => {
    const { onBlur, value } = this.props;

    if (isFunction(onBlur)) {
      onBlur(value);
    }
  };

  arrowRenderer = ({ onMouseDown }) => {
    const { arrowClassName } = this.props;

    return (
      <Icon icon="angle-down" onMouseDown={onMouseDown} className={clx('arrow', arrowClassName)} />
    );
  };

  clearRenderer = () => {
    const { clearClassName } = this.props;

    return <Icon icon="times" className={clx('clear', clearClassName)} />;
  };

  render() {
    const { readOnly, disabled, onBlur, className, ...props } = this.props;

    const selectClasses = clx(className, {
      'is-read-only': readOnly && !disabled,
    });

    const menuContainerStyle = {
      width: get(this.select, 'control.offsetWidth'),
      zIndex: Z_INDEX, // to render menu on top of components like footer
      ...props.menuContainerStyle,
    };

    return (
      <CustomSelect
        {...props}
        ref={c => {
          this.select = c;
        }}
        menuContainerStyle={menuContainerStyle}
        arrowRenderer={props.arrowRenderer || this.arrowRenderer}
        clearRenderer={props.clearRenderer || this.clearRenderer}
        disabled={readOnly || disabled}
        onBlur={this.handleBlur}
        className={selectClasses}
      />
    );
  }
}
